import React from 'react';

import { SisternodeOutlined } from '@ant-design/icons';

import Messages from 'i18n/messages/home';

import { RibbonButton } from 'common/components';
import { useGlobalModal } from 'hooks';

import './CreateAplControl.less';

const CreateAplControl = () => {
  const { openModal, MODAL_NAMES } = useGlobalModal();

  return (
    <>
      <RibbonButton
        size='small'
        icon={<SisternodeOutlined />}
        label={Messages.createApl}
        onClick={() => openModal(MODAL_NAMES.CREATE_APL)}
      />
    </>
  );
};

export default CreateAplControl;
